var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"account-menu-container"},[_c('account-menu',{attrs:{"menu-data":_vm.getMenu ? _vm.getMenu.data : [],"translations":_vm.translations,"vip-icon":_vm.getVipIcon(_vm.$shopConfig),"user":_vm.user,"data-sel":"left-desktop-menu"},on:{"logout":_vm.logout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }